// classe libelles avec les champs libelleFr, libelleTraduit, contexte

import { AbstractEntity } from "./AbstractEntity/AbstractEntity";

export class User extends AbstractEntity {
  id?: number;
  username?: string;
  email?: string;
  password?: string;
  roles?: string[];
  canDelete?: boolean;
}

// Default Admin User
export const DEFAULT_ADMIN: User = {
  id: 1,
  username: "admin",
  roles: ["ADMIN"],
  email: "admin@forterro.com",
  createdAt: "",
  createdBy: "",
  modifiedAt: "",
  modifiedBy: "",
  canDelete: false,
};
